import { createFileRoute } from "@tanstack/react-router";
import AdminAppointments from "@/pages/admin/AdminAppointments";

export const Route = createFileRoute("/_adminLayout/admin/appointments")({
  component: AdminAppointments,
});
